import { render, staticRenderFns } from "./CustomerInsight.vue?vue&type=template&id=0a5c2988&lang=pug&"
import script from "./CustomerInsight.vue?vue&type=script&lang=js&"
export * from "./CustomerInsight.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInsight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports